import styled from "@emotion/styled";

import { fontRobotoCondensed, transientOptions } from "shared/lib/styles";

import { ContentItemArticleWidget } from "scmp-app/components/content/content-item-render/variants/article-widget";
import { EntityLink } from "scmp-app/components/entity-link";
import { HomeFollowButton } from "scmp-app/components/home/follow-button";
import {
  StyledDesktopEntityFollowButton,
  StyledMobileEntityFollowButton,
} from "scmp-app/components/home/follow-button/styles";
import { StyledButton } from "scmp-app/scmp-sdk/components/follow-button/styles";

export const Title = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;

export const TopicContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  margin-block-start: 4px;
`;

export const TopicName = styled(EntityLink)`
  && {
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRobotoCondensed};
    font-style: normal;
    line-height: normal;
    text-decoration: none;
  }
`;

type StyledHomeFollowButtonProps = { $isFollowed: boolean };

export const StyledHomeFollowButton = styled(HomeFollowButton, {
  ...transientOptions,
})<StyledHomeFollowButtonProps>`
  display: flex;

  min-inline-size: max-content;

  ${StyledMobileEntityFollowButton} {
    display: block;
  }
  ${StyledDesktopEntityFollowButton} {
    display: none;
  }

  ${StyledButton} {
    ${props =>
      !props.$isFollowed &&
      `
      color: #2c4692;
      border-color: #788ac4;
    `}

    svg {
      path {
        fill: #2c4692;
      }
    }
  }
`;

export const StyledContentItemArticleWidget = styled(ContentItemArticleWidget)`
  margin-block-start: 8px;
  padding-block-start: 8px;
  border-block-start: 1px #dfdfdf solid;

  ${TopicContainer}+& {
    border-block-start: none;

    margin-block-start: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  padding-block-start: 12px;
  border-block-start: 1px solid #dfdfdf;
`;
